var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'asc-no-data--container',
    _vm.fullSize ? 'asc-no-data--container--full-size' : null ]},[_c('span',{staticClass:"asc-no-data--title"},[_vm._v(_vm._s(_vm.getText))])])}
var staticRenderFns = []

export { render, staticRenderFns }